import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import ViewMore from '../../../components/ViewMore';
import Faq from '../../../components/Faq';
import Why from '../../../components/Why';
import ProcessSlider2D from '../../../components/sliders/ProcessSlider2D';
import SolveProblems2D from '../../../components/video-production/explainer-videos/SolveProblems2D';
import Benefits2D from '../../../components/video-production/explainer-videos/Benefits2D';

import typesLottie from '../../../public/images/types.json';

lazyload({
  width: '100%',
});

const ExplainerVideos2D = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - 2D Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/2d-explainer-video" />
        <meta
          name="description"
          content="Elevate your brand with custom 2D explainer videos: uniquely crafted to highlight your message and captivate your audience."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/2d-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - 2D Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Elevate your brand with custom 2D explainer videos: uniquely crafted to highlight your message and captivate your audience."
        />
        <meta property="og:image" content="https://weprodigi.com/images/video-production/2d-explainer-video/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "Video Production - 2D Explainer Video | Prodigi",
              "description": "Elevate your brand with custom 2D explainer videos: uniquely crafted to highlight your message and captivate your audience.",
              "url": "https://weprodigi.com/video-production/2d-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Explainer Video Production",
                    "item": "https://weprodigi.com/video-production/explainer-videos"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Video Production - 2D Explainer Video | Prodigi",
                    "item": "https://weprodigi.com/video-production/2d-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "Video Production - 2D Explainer Video | Prodigi",
                "description": "Elevate your brand with custom 2D explainer videos: uniquely crafted to highlight your message and captivate your audience.",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "1300",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "John Doe"
                    },
                    "datePublished": "2024-02-14",
                    "reviewBody": "Excellent service! The explainer video they produced for us exceeded our expectations. Highly recommended."
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Jane Smith"
                    },
                    "datePublished": "2024-02-14",
                    "reviewBody": "We had a fantastic experience working with Weprodigi. The team was professional, responsive, and delivered a high-quality explainer video that perfectly captured our brand's essence. Highly recommended!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Alex Johnson"
                    },
                    "datePublished": "2024-02-12",
                    "reviewBody": "Weprodigi's 2D explainer video production exceeded our expectations. The video was creative, engaging, and delivered on time. We were impressed by their professionalism and attention to detail throughout the process. Highly recommend their services!"
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              },
              "mainEntityOfPage": {
                "@type": "FAQPage",
                "mainEntity": [
                  {
                    "@type": "Question",
                    "name": "How much does a 1-minute 2D animated explainer video cost?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "The average cost of a custom 2D animated video, running from 45 seconds to 1 minute, starts at $1200."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How much time does it take to create a 2D explainer video?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "2D explainer videos take 2-3 weeks to make and are the fastest type available for quick results."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How to make a 2D explainer video?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "A 2D explainer video production is a seven-step process: research, scriptwriting, storyboard, character creation and illustration, voiceover, background music, and final production."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Who need 2D explainer videos?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "2D explainer videos are useful for businesses, educational institutions, nonprofits, startups, marketing agencies, e-learning platforms, healthcare providers, event organizers, real estate agencies, and tech companies to convey information effectively."
                    }
                  }
                ]
              }
            }
                        
        `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/2d-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              2D Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/2d-explainer-video',
                name: '2D Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A 2D explainer video is what you are looking for when written text is not enough , or you need more action. Would you rather choose
                  a long article to read or watch a 1-minute video? We all know what you would choose. So lets embark, on a journey where vibrant
                  colors and graceful lines come alive transforming your message into an captivating story that resonates beyond words.
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What is A 2d explainer video animation?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/PElD4j_raE8?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Missouri Realtors | 2D Explainer Animation</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                A 2D animated explainer video is, like a canvas where still drawings come to life telling stories that capture your thoughts and
                messages. It's a blend of simplicity and complexity where paper meets animation to create a captivating experience. In a world
                overwhelmed with information, where people often lose interest quickly these animations serve as engaging beacons. They cut through
                the clutter. Focus on what matters, captivating viewers and guiding them from curiosity, to understanding. The art of 2D animation
                explainer videos goes beyond information delivery; it aims to mesmerize ensuring that your message not reaches the audience but also
                resonates with them.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  A 2D animated explainer video is, like a canvas where still drawings come to life telling stories that capture your thoughts and
                  messages. It's a blend of simplicity and complexity where paper meets animation to create a captivating experience. In a world
                  overwhelmed with information, where people often lose interest quickly these animations serve as engaging beacons. They cut through
                  the clutter. Focus on what matters, captivating viewers and guiding them from curiosity, to understanding. The art of 2D animation
                  explainer videos goes beyond information delivery; it aims to mesmerize ensuring that your message not reaches the audience but also
                  resonates with them.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to use 2d explainer video animation?
            </h2>
            <p className={'mt-20'}>
              High-quality video is a better way to tell a story to connect with your audience, teach them, and gain trust in your brand. Users claim
              they retain up to 95% of the information when learned through video. So why lose this huge potential and fall behind the competition? 
              Depending on the industry, 2D explainer videos can follow different objectives.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/R6YdRjnMPKI?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Tap'N'Care | 2D Explainer Animation</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  In the field of marketing and advertising 2D explainer videos play a role, in bridging the gap between concepts and audience
                  comprehension. These videos effectively transform product features and advantages into captivating stories that are easy to
                  understand. As a result viewers can remember the information easily. Moreover these videos not only increase the time visitors spend
                  on a website, which contributes to SEO rankings but they also serve as engaging content for social media and online advertising
                  campaigns. By delivering impactful messages they significantly improve conversion rates.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    In the field of marketing and advertising 2D explainer videos play a role, in bridging the gap between concepts and audience
                    comprehension. These videos effectively transform product features and advantages into captivating stories that are easy to
                    understand. As a result viewers can remember the information easily. Moreover these videos not only increase the time visitors
                    spend on a website, which contributes to SEO rankings but they also serve as engaging content for social media and online
                    advertising campaigns. By delivering impactful messages they significantly improve conversion rates.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  For education and training, 2D explainer videos offer an innovative approach to learning, breaking down complex topics into engaging
                  and understandable visual stories. These videos cater to diverse learning styles, making information more accessible and memorable.
                  They can be used to introduce new concepts, provide step-by-step tutorials, or summarize key points, enhancing the learning
                  experience by making it more interactive and enjoyable. Whether for academic purposes or professional development, 2D explainer
                  videos transform traditional education methods, fostering a more dynamic and effective learning environment.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Creative Writing Coach For education and training, 2D explainer videos offer an innovative approach to learning, breaking down
                    complex topics into engaging and understandable visual stories. These videos cater to diverse learning styles, making information
                    more accessible and memorable. They can be used to introduce new concepts, provide step-by-step tutorials, or summarize key
                    points, enhancing the learning experience by making it more interactive and enjoyable. Whether for academic purposes or
                    professional development, 2D explainer videos transform traditional education methods, fostering a more dynamic and effective
                    learning environment.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/FuCO0RDxcxc?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>C-Pro | Healthcare Product Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/FDl_Bbzxu1g?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Desert Teleheart | Mixed Media Animation</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Internal Communication and Presentations</h3>
                <p className={'mt-16 hidden md:block'}>
                  When it comes to communication and presentations 2D explainer videos have become the choice, for many with 75% of employees
                  expressing a preference for video over traditional learning methods. These videos have transformed how companies convey updates
                  policy changes and new employee onboarding making information not more accessible but more engaging. By incorporating presentations
                  into meetings they significantly increase attention and involvement turning gatherings into dynamic discussions. Moreover explainer
                  videos play a role, in enhancing teamwork by providing an concise way to share project updates, assign tasks and facilitate
                  brainstorming sessions.{' '}
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    When it comes to communication and presentations 2D explainer videos have become the choice, for many with 75% of employees
                    expressing a preference for video over traditional learning methods. These videos have transformed how companies convey updates
                    policy changes and new employee onboarding making information not more accessible but more engaging. By incorporating
                    presentations into meetings they significantly increase attention and involvement turning gatherings into dynamic discussions.
                    Moreover explainer videos play a role, in enhancing teamwork by providing an concise way to share project updates, assign tasks
                    and facilitate brainstorming sessions.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>BENEFITS OF 2D EXPLAINER VIDEOS</h2>
            <p className={'mt-20'}>
              Explainer videos, in 2D are excellent at simplifying concepts and turning them into engaging narratives bridging the gap, between
              information and easy comprehension by using vibrant visual storytelling. Lets delve into the benefits they offer.{' '}
            </p>
            <Suspense fallback={`Loading...`}>
              <Benefits2D />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our 2D Explainer Video Animation Process
            </h2>
            <ProcessSlider2D />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div className={'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-36'}>
              Calculate Your 2D Explainer Video Price
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Can A 2D Animated Explainer Video Help Your Business?
            </h2>
            <p className={'mt-20'}>2D animated explainer videos are cool and fun. But they are also tools designed to meet business objectives.</p>
            <Suspense fallback={`Loading...`}>
              <SolveProblems2D />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">Why Choose Us for Your 2D Explainer Video?</h2>
            <Why
              content={[
                {
                  title: 'We craft captivating narratives',
                  answer:
                    'We don’t just animate. We offer 2D explainer video production that resonates with your audience and establishes a connection.',
                },
                {
                  title: 'We value your time',
                  answer:
                    "We understand how time is crucial. That's why we offer customized 2D animation explainer videos to help you save time on complex production processes.",
                },
                {
                  title: 'We offer cost-effective solutions',
                  answer: 'Our full-service video production company has competitive pricing to ensure you get the best value for your investment.',
                },
                {
                  title: 'We focus on collaboration',
                  answer: 'Our dedicated team works closely with you throughout the process, making you part of video production.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'How much does a 1-minute 2D animated explainer video cost?',
                    answer: 'The average cost of a custom 2D animated video, running from 45 seconds to 1 minute, starts at $1200.',
                  },
                  {
                    title: 'How to make a 2D explainer video?',
                    answer:
                      'A 2D explainer video production is a seven-step process: research, scriptwriting, storyboard, character creation and illustration, voiceover, background music, and final production.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How much time does it take to create a 2D explainer video?',
                    answer: '2D explainer videos take 2-3 weeks to make and are the fastest type available for quick results.',
                  },
                  {
                    title: 'Who need 2D explainer videos?',
                    answer:
                      '2D explainer videos are useful for businesses, educational institutions, nonprofits, startups, marketing agencies, e-learning platforms, healthcare providers, event organizers, real estate agencies, and tech companies to convey information effectively.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideos2D;
